import ListGroup from 'react-bootstrap/ListGroup';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import useStaticNotifications from '@/hooks/useStaticNotifications';
import { MenuLinksProps } from '@/types/props/components';
import uiItems from '@/constants/ui-items/index.constants';
import MenuItem from './MenuItem';
import MenuLanguageItem from './MenuLanguageItem';
import { MenuLinksMainItem } from '@/types/constants/types';
import { generateMenuItemComponent } from '@/hooks/ui/ui-items.ui.utils';
import { MenuMemoLogoutLink } from '@/components/common/LogoutLinks';

const {
  suggestBottle: suggestBottleUiItem,
  notiSettings: notiSettingsUiItem,
  main: menuLinksUiItem,
} = uiItems.header.menuLinks;

const MenuLinks = ({ ctaCountQuery, userQuery, queryClient, tHeader }: MenuLinksProps) => {
  const router = useRouter();
  const { t } = useTranslation('index');
  const { t: tCommon } = useTranslation('common');
  const { totalNoti = 0 } = useStaticNotifications();
  const { buyerNotificationsCallToAc = 0, sellerNotificationsCallToAc = 0 } =
    ctaCountQuery.data || {};

  const menuItemComponentGenerator = useCallback(
    (item: MenuLinksMainItem, index: number) =>
      generateMenuItemComponent(item, index, t, router.pathname),
    [t, router.pathname]
  );

  const NotiSettingsUiItems = useMemo(
    () => notiSettingsUiItem(totalNoti).map(menuItemComponentGenerator),
    [totalNoti, menuItemComponentGenerator]
  );

  return (
    <>
      <ListGroup variant="flush">
        {menuLinksUiItem(buyerNotificationsCallToAc, sellerNotificationsCallToAc).map(
          menuItemComponentGenerator
        )}
      </ListGroup>
      <hr />

      <ListGroup variant="flush">
        <MenuItem
          href={suggestBottleUiItem.href}
          badgeCount={suggestBottleUiItem.badgeCount}
          icon={suggestBottleUiItem.icon}
          pathname={router.pathname}
          mainText={translationFallback(
            suggestBottleUiItem.tKey,
            t(suggestBottleUiItem.tKey),
            suggestBottleUiItem.tFallback
          )}
        />
      </ListGroup>
      <hr />
      <ListGroup variant="flush">
        {NotiSettingsUiItems}
        <MenuLanguageItem
          mainText={translationFallback('language', tCommon('language'), 'Language')}
          locale={router.locale ?? 'EN'}
          tHeader={tHeader}
          tCommon={tCommon}
          router={router}
          userExist={Boolean(userQuery.data)}
          queryClient={queryClient}
        />
      </ListGroup>
      <hr />
      <ListGroup>
        <MenuMemoLogoutLink />
      </ListGroup>
    </>
  );
};

export default MenuLinks;
